import Tooltip from 'rc-tooltip';
import React from 'react';

import MaterialIcon from '@/components/Icon/MaterialIcon';
import Picture from '@/components/Picture';

export default function MatchStateDescription({
  stateConfig,
  editable,
  candidate,
  suggestedByResearch,
  onOpenSelectMatchState,
}: any) {
  return (
    <Tooltip
      overlay={<div style={{ maxWidth: 300 }}>{stateConfig.description}</div>}
      placement="topRight"
      trigger={['hover', 'click']}
    >
      <div
        onClick={onOpenSelectMatchState}
        onKeyUp={onOpenSelectMatchState}
        style={{ cursor: editable ? 'pointer' : 'normal' }}
      >
        {suggestedByResearch && candidate.created_by ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'inline-block' }}>Suggested by {candidate.created_by.name}</div>
            <Picture
              user={candidate.created_by}
              size={30}
              style={{ marginLeft: 5, display: 'inline-block' }}
              link={false}
            />
          </div>
        ) : (
          <div>
            {stateConfig.label}{' '}
            <MaterialIcon
              icon={stateConfig.icon}
              color={stateConfig.color}
              size={16}
              style={{
                verticalAlign: 'bottom',
                width: 16,
                marginLeft: 3,
              }}
            />
          </div>
        )}
      </div>
    </Tooltip>
  );
}
